import React from 'react';
import Credits from './Credits';

function Start(props) {
    return (
        <div className="start__info">
            <h2>{props.strings.start.use_your_intel}</h2>
            <h1>{props.strings.start.is_it_bbb}</h1>
            <button className="startButton" onClick={props.onClickStart}><span className="startButton__text">{props.strings.start.take_quiz}</span></button>
            <h3>{props.strings.start.in_cinemas}</h3>
            <Credits strings={props.strings.credits} />
        </div>
    );
}

export default Start;


/** WEBPACK FOOTER **
 ** ./src/components/Start.js
 **/